export default "__VITE_ASSET__Di_9uH9t__"